import React from 'react';
import breadcrumbContext from './BreadcrumbContext';

const useBreadcrumbContext = () => React.useContext(breadcrumbContext);

export default useBreadcrumbContext;
